/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_4_AInputs */

const en_control_faq_4_a = /** @type {(inputs: Control_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is your visible overall combat-power indicator. Read the dedicated explanation for progression advice.`)
};

const zh_control_faq_4_a = /** @type {(inputs: Control_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是可查看的整体战斗能力指标，详情请看专门攻略。`)
};

/**
* | output |
* | --- |
* | "It is your visible overall combat-power indicator. Read the dedicated explanation for progression advice." |
*
* @param {Control_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_4_a = /** @type {((inputs?: Control_Faq_4_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_4_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_4_a(inputs)
	return zh_control_faq_4_a(inputs)
});
export { control_faq_4_a as "control.faq.4.a" }